<template>
  <v-menu
    ref="date-menu"
    v-model="dateMenu"
    :disabled="readonly"
    :close-on-content-click="false"
    :nudge-right="30"
    class="a-date-field-menu"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <a-text-field
        v-model="formattedDate"
        :validator="validator"
        :label="label"
        :prependIcon="prependIcon"
        readonly
        :on="on"
      ></a-text-field>
    </template>
    <v-date-picker
      ref="date-picker"
      v-bind:value="value"
      color="primary lighten-2"
      :min="computedMin"
      :max="computedMax"
      :allowed-dates="methodAllowedDates"
      @change="$refs['date-menu'].save(value)"
      @input="$emit('input', $event)"
    ></v-date-picker>
  </v-menu>
</template>

<script>
/**
 * @vue-prop {Boolean} value - Value
 * @vue-prop {Object} validator - Validator
 * @vue-prop {String} label - Label
 * @vue-prop {String} prependIcon - Icon
 * @vue-prop {Boolean} readonly - Read only
 * @vue-prop {Boolean} birthdate - Birth date
 * @vue-prop {Boolean} future - Future
 * @vue-prop {Boolean} disableWeekends - Disable weekends
 * @vue-prop {String} min - Minimum
 * @vue-prop {String} max - Maximum
 * @vue-prop {Function} allowedDates - Allowed dates
 * @vue-event {Boolean} methodAllowedDates - Allow dates
 * @vue-computed {Date} formattedDate
 * @vue-computed {Date} computedMin
 * @vue-computed {Date} computedMax
 */

// @ is an alias to /src
import ATextField from "@/components/fields/ATextField.vue";

import { parseISO } from "date-fns";

export default {
  name: "a-date-field-menu",

  components: {
    ATextField
  },

  data() {
    return {
      dateMenu: false
    };
  },

  props: {
    value: String,
    validator: Object,
    label: String,
    prependIcon: String,
    readonly: Boolean,
    birthdate: Boolean,
    future: Boolean,
    disableWeekends: Boolean,
    min: String,
    max: String,
    allowedDates: Function
  },

  methods: {
    methodAllowedDates(val) {
      if (this.allowedDates) {
        return this.allowedDates;
      }
      if (this.disableWeekends) {
        return ![6, 0].includes(new Date(val).getDay());
      }

      return true;
    }
  },

  watch: {
    dateMenu(val) {
      val &&
        this.birthdate &&
        setTimeout(() => (this.$refs["date-picker"].activePicker = "YEAR"));
    }
  },

  computed: {
    formattedDate() {
      return this.value ? this.$d(parseISO(this.value), "short") : "";
    },
    computedMin() {
      if (this.min) {
        return this.min;
      }
      if (this.birthdate) {
        return "1870-01-01";
      }
      if (this.future) {
        let date = new Date();
        date.setDate(new Date().getDate() + 1);
        return date.toISOString().substr(0, 10);
      }

      return undefined;
    },
    computedMax() {
      if (this.max) {
        return this.max;
      }
      if (this.birthdate) {
        return new Date().toISOString().substr(0, 10);
      }

      return undefined;
    }
  }
};
</script>
